import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import { StoreProvider } from './contexts/StoreProvider';
import IntlProviderNew from './translations/IntlProviderNew';
 

                
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <StoreProvider>
    <IntlProviderNew>
      <Router>
        <App />
      </Router>
    </IntlProviderNew>
  </StoreProvider>
);